import { useCallback } from 'react';
import { useEncaissementStore } from '../stores/encaissementStore';
import { isEmbeddedInPortal, openPaymentInPortal } from '../utils/portal/openInPortal';
import type { RelanceTaskItem } from '../types/customerFollowUp/relanceTask';

/**
 * Opens AcombaGO's payment window for the relance's customer. Returns false when that cannot happen —
 * outside the portal, or for a customer without an Acomba id — so the caller can tell the user. A null
 * `id` collects for a customer whose relance is only expected: there is nothing to record the payment on.
 */
type CollectableRelance = Pick<RelanceTaskItem, 'customerExternalId' | 'totalDue'> & { id: string | null };

export function useCollectPayment(): (item: CollectableRelance) => boolean {
    const setPendingEncaissement = useEncaissementStore(s => s.setPending);

    return useCallback((item: CollectableRelance) => {
        if (!isEmbeddedInPortal() || item.customerExternalId === null) return false;
        setPendingEncaissement(item.customerExternalId, item.id);
        openPaymentInPortal(item.customerExternalId, item.totalDue);
        return true;
    }, [setPendingEncaissement]);
}
